import { createContext, useContext } from 'react';
export const BlockContext = createContext({
    id: null,
    block: null,
    extraContext: {},
});
export const useBlock = () => {
    const context = useContext(BlockContext);
    return context;
};
//# sourceMappingURL=block.hook.js.map